import casualEncounterIcon from '../../casual-encounter-icon.svg';
import salesPresentationIcon from '../../sales-presentation-icon.svg';
import phoneCallIcon from '../../phone-call-icon.svg';
import qaIcon from '../../qa-icon.svg';

export const meetingTypes = [
    {
        type: 'Elevator Pitch',
        icon: phoneCallIcon,
        recordingKey: 'elevator_pitch',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 1,
        level: 1,
        description: `The Elevator Pitch is applied in a cold call.  The focus is on brevity.  The seller talks for 30 seconds to a minute and briefly covers the background of the company, the primary differentiators, clearly states the  problem the company solves, and briefly mentions the offerings.  The seller then concludes by asking for time on the prospects calendar in the event of a call or asking to hear about the other party's company if in some sort of personal setting.`
        
    },
    {
        type: 'Casual Encounter',
        icon: casualEncounterIcon,
        recordingKey: 'casual_encounter',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 2,
        level: 1,
        description: `The Casual Encounter is the most common form of sales meeting and often the most difficult as it is generally executed without notes.  Think of this as the 30 minute online or in person meeting where the seller has to lead for 5-7 minutes.  The goal is for the seller to clearly articulate each aspect of the messaging components at a level of detail that allows the prospect to clearly understand the seller's company and then get to the ask to determine if the prospect has the problem that the sellers company solves.`
    },

    {
        type: 'Sales Presentation / Demo',
        icon: salesPresentationIcon,
        recordingKey: 'sales_presentation',
        disabled: false,
        minParticipants: 2,
        maxParticipants: 4,
        level: 1,
        description: `The Sales Presentation / Demo recording type is for either a sales presentation or a demonstration. This is a longer, in-depth meeting designed to last 20-30 minutes. The salesperson is expected to provide a comprehensive overview of the company, thoroughly cover all differentiators, addressable problems, and offerings, and demonstrate expertise throughout. This format requires the seller to cover nearly all relevant information, ensuring the prospect gains a deep understanding of the company and its value.`
    },
    {
        type: 'Elevator Pitch',
        icon: phoneCallIcon,
        recordingKey: 'elevator_pitch_2',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 1,
        level: 2,
        interactions: {
            questions: 1, 
        },
        description: `The Elevator Pitch is applied in a cold call.  The focus is on brevity.  The seller talks for 30 seconds to a minute and briefly covers the background of the company, the primary differentiators, clearly states the  problem the company solves, and briefly mentions the offerings.  The seller then concludes by asking for time on the prospects calendar in the event of a call or asking to hear about the other party's company if in some sort of personal setting.`

    },
    {
        type: 'Casual Encounter',
        icon: casualEncounterIcon,
        recordingKey: 'casual_encounter_2',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 2,
        level: 2,
        interactions: {
            questions: 1, 
        },
        description: `The Casual Encounter is the most common form of sales meeting and often the most difficult as it is generally executed without notes.  Think of this as the 30 minute online or in person meeting where the seller has to lead for 5-7 minutes.  The goal is for the seller to clearly articulate each aspect of the messaging components at a level of detail that allows the prospect to clearly understand the seller's company and then get to the ask to determine if the prospect has the problem that the sellers company solves.`
    },

    {
        type: 'Sales Presentation / Demo',
        icon: salesPresentationIcon,
        recordingKey: 'sales_presentation_2',
        disabled: false,
        minParticipants: 2,
        maxParticipants: 4,
        level: 2,
        interactions: {
            questions: 1,
        },
        description: `The Sales Presentation / Demo recording type is for either a sales presentation or a demonstration. This is a longer, in-depth meeting designed to last 20-30 minutes. The salesperson is expected to provide a comprehensive overview of the company, thoroughly cover all differentiators, addressable problems, and offerings, and demonstrate expertise throughout. This format requires the seller to cover nearly all relevant information, ensuring the prospect gains a deep understanding of the company and its value.`
    },
    {
        type: 'Messaging Defense',
        icon: qaIcon,
        recordingKey: 'prospect_prep',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 3,
        level: 3,
        flowType: 'sequential',
        questionCount: { min: 3, max: 7, default: 5 },
        description: `Murphy reads your company profile and uploaded collateral, then plays a skeptical, well-researched prospect. Practice handling realistic objections about your competitors, pricing, offerings, and differentiators. Grading focuses on how well you leverage company knowledge to deliver persuasive responses.`
    },
    {
        type: 'Objection Handling',
        icon: qaIcon,
        recordingKey: 'qa_practice',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 3,
        level: 3,
        flowType: 'sequential',
        questionCount: { min: 3, max: 7, default: 5 },
        description: `Practice handling objections and answering questions from your company's Q&A library. Murphy asks questions sequentially, waiting for your response before proceeding. This mode uses voice detection to automatically advance to the next question when you finish speaking, helping you practice delivering confident, comprehensive answers.`
    },
    {
        type: 'Document Defense',
        icon: salesPresentationIcon,
        recordingKey: 'deal_coaching',
        disabled: false,
        minParticipants: 1,
        maxParticipants: 3,
        level: 3,
        flowType: 'sequential',
        questionCount: { min: 3, max: 7, default: 5 },
        description: `Upload an RFP, proposal, or SOW and Murphy will generate custom questions based on the document and your company profile. Practice delivering confident, comprehensive answers tailored to the specific deal.`
    },
    {
        type: 'Investor Pitch',
        icon: salesPresentationIcon,
        recordingKey: 'investor_pitch',
        disabled: false,
        minParticipants: 0,
        maxParticipants: 0,
        level: 4,
        description: `Practice your investor pitch with screen sharing. Present your pitch deck as you would to VCs or angel investors. Murphy evaluates your pitch against what investors actually look for: traction, team, market opportunity, financials, delivery, and defensibility.`
    }
];
